import { Modal } from "react-bootstrap";
import React, { useRef } from "react";
import { InvoiceCreateForm } from "./InvoiceCreateForm";
import { useDispatch } from "react-redux";
import { toast } from "react-hot-toast";

import { createInvoice } from "../../../_redux/invoices/invoicesActions";
export function InvoiceCreateModal({ show, onHide }) {
  const btnRef = useRef();

  const dispatch = useDispatch();

  const onCreateClick = () => {
    if (btnRef && btnRef.current) {
      btnRef.current.click();
    }
  };

  const onCreateInvoice = (invoice) => {
    dispatch(createInvoice(invoice))
      .then(() => {
        toast.success("فاکتور با موفقیت ایجاد شد");
        onHide();
      })
      .catch(() => {
        toast.error("خطا هنگام ایجاد فاکتور");
        onHide();
      });
  };

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>ایجاد فاکتور جدید</Modal.Title>
      </Modal.Header>
      <Modal.Body></Modal.Body>
      <InvoiceCreateForm btnRef={btnRef} createInvoice={onCreateInvoice} />
      <Modal.Footer>
        <div>
          <button
            type={"button"}
            onClick={onHide}
            className={"btn btn-light btn-elevate"}
          >
            لغو
          </button>
          <> </>
          <button
            type={"button"}
            onClick={onCreateClick}
            className={"btn btn-primary btn-elevate"}
          >
            ایجاد فاکتور
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
